import styled from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { theme } from '@jadwalh/ui';

export const ToastContainerWrapper = styled(ToastContainer)`
  position: unset;
`;
interface MainBodyProps {
  bgColor: string;
  textColor: string;
  btnColor: string;
  separatorColor: string;
  borderColor: string;
  bgAvailableDaysColor: string;
  unavailableDaysColor: string;
  isInline: string;
}

export const MainBody = styled.main<MainBodyProps>`
  padding-top: ${({ textColor, isInline }: any) =>
    textColor ? (isInline === 'true' ? '10px' : '0px') : '24px'};
  border-radius: ${({ isInline }: any) =>
    isInline === 'true' ? '8px' : '0px'} !important;
  @media (max-width: 767px) {
    padding-bottom: 0;
    padding-top: 0;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  span,
  label,
  div,
  #select_zone label p {
    color: ${({ textColor }: any) => textColor && textColor} !important;
    .mantine-Select-rightSection {
      svg {
        color: ${({ btnColor }: any) => btnColor && btnColor} !important;
      }
    }
  }
  #mainBody {
    background-color: ${({ bgColor }: any) => bgColor && bgColor};
    box-shadow: ${({ isInline, textColor }: any) =>
      isInline === 'true' && !textColor ? '0 0 8px 2px rgb(0 0 0 / 8%)' : 'none'} !important;
    border-radius: ${({ isInline }: any) =>
      isInline === 'true' ? '8px' : '0px'} !important;

    /* Override class for JavaScript-controlled background */
    &.js-controlled-bg {
      background-color: #f2f2f2 !important;
    }
    .questionFormWrapper {
      border: none;
    }
    .footer {
      background-color: ${({ bgColor }: any) => bgColor && bgColor};
    }
    .headerBar {
      display: none;
    }
    .learnMore {
      color: ${({ btnColor }: any) => btnColor && btnColor} !important;
    }

    .error-text {
      color: ${theme.colours.error} !important;
    }

    .footer {
      .backBtn {
        background-color: ${({ bgColor }: any) =>
          bgColor && bgColor} !important;
        span {
          color: ${({ textColor }: any) => textColor && textColor} !important;
        }
        &:hover {
          background-color: ${({ bgAvailableDaysColor }: any) =>
            bgAvailableDaysColor && bgAvailableDaysColor} !important;
        }
      }
    }
    .mantine-Checkbox-input:checked {
      background-color: ${({ btnColor }: any) =>
        btnColor && btnColor} !important;
      border-color: ${({ btnColor }: any) => btnColor && btnColor} !important;
    }
    .mantine-Radio-inner input:checked {
      border-color: ${({ btnColor }: any) => btnColor && btnColor} !important;
    }
    .mantine-Radio-inner svg {
      color: ${({ btnColor }: any) => btnColor && btnColor} !important;
    }
    .questionFormWrapper {
      border: none;
    }
    .background {
      background-color: ${({ bgColor }: any) => bgColor && bgColor} !important;
      border-color: ${({ bgColor }: any) => bgColor && bgColor} !important;
    }

    .calender-wrapper {
      .mantine-Calendar-calendar {
        th {
          color: ${({ textColor }: any) => textColor && textColor} !important;
        }
        .mantine-CalendarHeader-calendarHeader {
          background-color: ${({ bgColor }: any) =>
            bgColor && bgColor} !important;
          border: ${({ borderColor }: any) =>
            borderColor && `1px solid ${borderColor}`} !important;
          button {
            color: ${({ textColor }: any) => textColor && textColor} !important;
            height: 33px;
            svg {
              color: ${({ unavailableDaysColor }: any) =>
                unavailableDaysColor && unavailableDaysColor} !important;
            }
            &[data-disabled] {
              color: ${({ textColor }: any) =>
                textColor && textColor} !important;
            }
            opacity: 1;
          }
        }
        .mantine-Day-day {
          background-color: ${({ bgAvailableDaysColor }: any) =>
            bgAvailableDaysColor && bgAvailableDaysColor} !important;
          color: ${({ textColor }: any) => textColor && textColor} !important;
        }
        button {
          border-color: ${({ borderColor }: any) =>
            borderColor && borderColor} !important;
          background-color: ${({ bgColor }: any) =>
            bgColor && bgColor} !important;
          &:hover {
            border-color: ${({ btnColor }: any) =>
              btnColor && btnColor} !important;
          }
          &[data-selected] {
            border-color: ${({ btnColor }: any) =>
              btnColor && btnColor} !important;
            background-color: ${({ btnColor }: any) =>
              btnColor ? btnColor : '#000000'} !important;
            color: ${({ bgColor }: any) => bgColor && bgColor} !important;
          }
          &[data-disabled] {
            background-color: ${({ bgColor }: any) =>
              bgColor && bgColor} !important;
            border-color: ${({ bgColor }: any) =>
              bgColor && bgColor} !important;
            color: ${({ unavailableDaysColor }: any) =>
              unavailableDaysColor && unavailableDaysColor} !important;
          }
        }
        .mantine-Calendar-monthsList,
        .mantine-Calendar-yearsList {
          button:hover {
            color: ${({ btnColor }: any) => btnColor && btnColor} !important;
          }
        }
      }
    }
    .link {
      label,
      span,
      a,
      svg {
        color: ${({ btnColor }: any) => btnColor && btnColor} !important;
      }
    }
    .button {
      background-color: ${({ btnColor }: any) =>
        btnColor && btnColor} !important;

      span {
        color: ${({ btnColor }: any) => btnColor && 'white'} !important;
      }
    }

    .timeWrapper {
      #noTimeNote {
        color: ${({ unavailableDaysColor }: any) =>
          unavailableDaysColor && unavailableDaysColor} !important;
      }
      #timeBlock {
        .time_item {
          background-color: ${({ bgAvailableDaysColor }: any) =>
            bgAvailableDaysColor && bgAvailableDaysColor} !important;
          span,
          p {
            color: ${({ textColor }: any) => textColor && textColor} !important;
          }
          &:hover {
            border-color: ${({ btnColor }: any) =>
              btnColor && btnColor} !important;
            span,
            p {
              color: ${({ textColor }: any) =>
                textColor && textColor} !important;
            }
          }
        }
        .mantine-Radio-root[data-checked='true'] div.time_item {
          background-color: ${({ btnColor }: any) =>
            btnColor && btnColor} !important;
          color: ${({ bgColor }: any) => bgColor && bgColor} !important;
          span {
            color: ${({ bgColor }: any) => bgColor && bgColor} !important;
          }
        }
      }
      .time-title {
        background-color: ${({ bgColor }: any) =>
          bgColor && bgColor} !important;
      }

      &::-webkit-scrollbar {
        width: 4px;
      }

      &::-webkit-scrollbar-track {
        border-radius: 4px;
        box-shadow: inset 0 0 6px
          ${({ bgColor }: any) => (bgColor ? bgColor : '#ececec')} !important;
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${({ separatorColor }: any) =>
          separatorColor ? separatorColor : '#cdcdd7'} !important;
        border-radius: 4px;
      }
    }
    .mantine-Select-root {
      input,
      svg {
        color: ${({ textColor }: any) => textColor && textColor} !important;
        cursor: pointer;
        background-color: ${({ bgColor }: any) =>
          bgColor && bgColor} !important;
      }
    }
    #google-calendar-btn,
    #apple-calendar-btn {
      color: ${({ btnColor }: any) => btnColor && btnColor} !important;
    }
    .separator {
      &::after {
        background-color: ${({ separatorColor }: any) =>
          separatorColor && separatorColor} !important;
      }
    }
    .time-title {
      label {
        color: ${({ textColor }: any) => textColor && textColor} !important;
      }
      &::after {
        background-color: ${({ borderColor }: any) =>
          borderColor && `${borderColor} !important`};
      }
    }
    .infoWrapper {
      border-color: ${({ separatorColor }: any) =>
        separatorColor && separatorColor} !important;
      svg {
        path {
          color: ${({ textColor }: any) => textColor && textColor} !important;
        }
      }
    }
    .calenders {
      border-color: ${({ separatorColor }: any) =>
        separatorColor && separatorColor} !important;
      svg {
        path {
          fill: ${({ textColor }: any) => textColor && textColor} !important;
        }
      }
    }
    .backBtn {
      svg {
        path {
          fill: ${({ btnColor }: any) => btnColor && btnColor} !important;
        }
      }
    }
    .success-footer {
      p {
        border-color: ${({ separatorColor }: any) =>
          separatorColor && separatorColor} !important;
      }
    }
    .questions-container {
      &:lang(en) {
        border-left: ${({ separatorColor }: any) =>
          separatorColor && `1px solid ${separatorColor}`} !important;
      }
      &:lang(ar) {
        border-right: ${({ separatorColor }: any) =>
          separatorColor && `1px solid ${separatorColor}`} !important;
      }
    }
    @media (max-width: 767px) {
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
    }
  }
  .react-select__control {
    div {
      color: hsl(0, 0%, 20%) !important;
    }
    svg {
      color: rgb(204, 204, 204) !important;
    }
    ::-webkit-scrollbar {
      width: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: ${({ separatorColor }: any) =>
        separatorColor && separatorColor} !important;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${({ bgColor }: any) => bgColor && bgColor} !important;
      border-radius: 4px;
    }
  }
`;
